module.exports = __webpack_public_path__ + "static/img/float-tile-instrument.628e950.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/float-tile-instrument.jpg
// module id = pENx
// module chunks = 1